import { render, staticRenderFns } from "./ProductionItem.vue?vue&type=template&id=6fe23aee&scoped=true&"
import script from "./ProductionItem.vue?vue&type=script&lang=js&"
export * from "./ProductionItem.vue?vue&type=script&lang=js&"
import style0 from "./ProductionItem.vue?vue&type=style&index=0&id=6fe23aee&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe23aee",
  null
  
)

export default component.exports